import script from "./UnsavedChangesDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./UnsavedChangesDialog.vue?vue&type=script&setup=true&lang=ts"

import "./UnsavedChangesDialog.vue?vue&type=style&index=0&id=c48d94e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c48d94e6"]])

export default __exports__